/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './Button.css';

const Button = ({ onClick, children, className, isDisabled, size, style, type }) => (
  <button
    disabled={isDisabled}
    className={classnames('cmp-button', className, {
      'cmp-button-small': size === 'small',
      'cmp-button-medium': size === 'medium',
    })}
    onClick={onClick}
    style={style}
    type={type}
  >
    {children}
  </button>
);
Button.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  size: PropTypes.oneOf(['medium', 'small']),
  style: PropTypes.any,
  type: PropTypes.string,
};
Button.defaultProps = {
  size: 'medium',
  type: 'button',
};

export const SecondaryButton = (props) => (
  <Button {...props} className={classnames(props.className, '_secondary-button font-color-gsMedDark border-color-gsMedLight')} />
)

export const GroupThemedSecondaryButton = (props) => (
  <Button {...props} className={classnames(props.className, '_secondary-button theme-group base color')} />
)

export const GroupThemedPrimaryButton = (props) => (
  <Button {...props} className={classnames(props.className, 'theme-group base background')} />
)

export const DestructivePrimaryButton = (props) => (
  <Button {...props} className={classnames(props.className, 'cmp-button-destructive')} />
)

export default Button;